"use client";

import { useEffect, useState } from "react";
import { supabase } from '@/utils/supabase/client'; // FIXED: Correct path
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle, AlertCircle } from "lucide-react";
import { showSuccess, showError } from "@/utils/toast";
import { testSupabaseConnection } from "@/utils/supabase/client";

const ConnectionTest: React.FC = () => {
  const [isConnected, setIsConnected] = useState<boolean | null>(null);

  useEffect(() => {
    const checkConnection = async () => {
      try {
        const connected = await testSupabaseConnection();
        setIsConnected(connected);
      } catch (error) {
        console.error('Connection test failed:', error);
        setIsConnected(false);
      }
    };

    checkConnection();
  }, []);

  return (
    <div className="container mx-auto p-4">
      <Card>
        <CardHeader>
          <CardTitle>Supabase Connection Test</CardTitle>
        </CardHeader>
        <CardContent>
          {isConnected === null ? (
            <div>Testing connection...</div>
          ) : isConnected ? (
            <div className="flex items-center space-x-2">
              <CheckCircle className="text-green-500" />
              <span>Successfully connected to Supabase!</span>
            </div>
          ) : (
            <div className="flex items-center space-x-2">
              <AlertCircle className="text-red-500" />
              <span>Failed to connect to Supabase. Check your environment variables.</span>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default ConnectionTest;